import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pre-loader',
  templateUrl: './pre-loader.component.html',
  styleUrls: ['./pre-loader.component.css']
})
export class PreLoaderComponent implements OnInit {
  progress: boolean;
  checkrobot: boolean;
  ticks: number;

  constructor() {
    this.checkrobot = false;
    this.progress = false;
  }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/pre-loader/pre-loader.component.ts